import Vue from "vue";
import Vuetify from "vuetify"; // DEFINITELY NOT "vuetify/lib"
import "vuetify/dist/vuetify.min.css"; // Add this line
import "@mdi/font/css/materialdesignicons.css"; //material icons
import "vue-snotify/styles/material.css"; //notifications component style sheet

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#582668",
        secondary: "#fdaa00",
        accent: "#382143",
        greyBackground: "#E0E0E0",
        lightGrey: '#E5E5E5'
      },
      dark: {
        primary: "#582668",
        secondary: "#fdaa00",
        accent: "#382143",
        greyBackground: "#E0E0E0"
      },
    },
  },
};

export default new Vuetify(opts);
